import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameMNS2} from "../base/BaseGameMNS2";
import {SharedCamera} from "./SharedCamera";
import {PinchDetectionHandler} from "./PinchDetectionHandler";
import {Level1} from "./Level1";
import {Level2} from "./Level2";
import {Level3} from "./Level3";
import {FaceLandmarker, FilesetResolver} from "@mediapipe/tasks-vision";

// Constructor
export class CameraApp extends BaseGameMNS2 {

  constructor() {
    super(`data/camera.json`);

    gsap.registerPlugin(Draggable)
    gsap.registerPlugin(InertiaPlugin)
  }

  // To be overridden in child games
  initGame() {

    // Seve final screen ID
    this.seveCtaScreenID = 3;
    this.seveCommunication.on("buttonPressed", (e) => this.onButtonPressed(e));

    return new Promise(async (resolve, reject) => {

      // TODO Complete message handling when final screen will be integrated
      this.seveCommunication.on("buttonPressed", (e) => {
        // TODO Set good screen IDs
        console.log("buttonPressed")
        if (this.currentScreen === 7) this.goToScreen(8);
      })

      // console.log("init game camera app")

      this.visionEngine = await this.initFaceDetector();

      this.cameraFeed = new SharedCamera({
        visionEngine: this.visionEngine
      });
      // this.cameraFeed.play(); // start the shared camera so we can use it in game

      // If we are not on a multitouch device, we'll simulate a pinch with a gesture instead
      this.pinchDetection = new PinchDetectionHandler({simulate: window.navigator.maxTouchPoints < 2});

      this.level1 = new Level1({
        cameraFeed: this.cameraFeed,
        tooltipCallback: this.toggleTooltip.bind(this),
        // visionEngine: this.visionEngine
      });

      this.level2 = new Level2({
        cameraFeed: this.cameraFeed
      });

      this.level3 = new Level3({
        cameraFeed: this.cameraFeed,
        tooltipCallback: this.toggleTooltip.bind(this),
        // visionEngine: this.visionEngine
      });

      super.initGame();

      // TODO: For debugging
      // this.level = "level3";
      // super.initGame(2);


      resolve();
    });

  }

  async initFaceDetector() {
    const wasmBasePath = (inElectron() ? appPath() + "/" : "");
    console.log("Using WASM basepath: " + wasmBasePath)
    const vision = await FilesetResolver.forVisionTasks(wasmBasePath + "js/libs/mediapipe/wasm");

    const visionEngine = await FaceLandmarker.createFromOptions(vision, {
      baseOptions: {
        modelAssetPath: 'js/libs/mediapipe/face_landmarker.task'
      },
      runningMode: 'VIDEO',
      numFaces: 1,
      outputFacialTransformationMatrixes: true,
      minFaceDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5
    });
    return visionEngine;
  }

  initScreen(screenId) {
    super.lottieAutoPlaybackForScreen(screenId);

    const screenIdNoLevel = parseInt(screenId.toString().replace("-" + this.level, ""));
    console.log("initScreen ids:", {screenIdNoLevel: screenIdNoLevel, screenId: screenId, level: this.level});

    // Handle additional tools visibility

    if (screenIdNoLevel === 1) {
      this.seveCommunication.sendMessage(0);

    } else if (screenIdNoLevel === 2) {
      this.seveCommunication.sendMessage(1);

      if (this.level === "level1") {
        this.level1.start();
      }
      if (this.level === "level2") {
        this.level2.start();
      } else if (this.level === "level3") {
        this.level3.start();
      }

    } else if (screenIdNoLevel === 3) {
      this.seveCommunication.sendMessage(3);
      this.audio.play("audio/MNS2_Communs_SFX/MNS2_ME_SFXpartage.mp3", 1, true)
      this.seveVideoPlayback("cta")
      // Auto quit app
      this.currentTimeline = gsap.timeline();
      this.currentTimeline.add(() => this.reset(), 14)
    }

    // Changle language switcher position
    this.setAdditionalToolsVisibility((screenId !== 1 && screenId !== this.seveCtaScreenID));

  }

  updateSeveVideosSrc(language) {
    super.updateSeveVideosSrc(language,
      "videos/seve_A/ZONE2_ME_MNS2_INTNUM_ENVOIE_SEVE_{{LANG}}.mp4",
      "videos/seve_B/ZONE2_ME_MNS2_INTNUM_SEVE_ENVOYE_{{LANG}}.mp4"
    );
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {
    // TODO: Reset things here

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    const resetCallback = () => {
      // Things that reset after goToScreen
      this.seveVideoPlayback("none")

      this.level1.reset();
      this.level2.reset();
      this.level3.reset();
    }

    // Super
    return super.reset(screenId, resetCallback);

  }

}
